export default __webpack_public_path__ + "cta-card.png";